/**
 * Renderer-side brand utilities.
 * Brand is inferred from window.location.hostname (matches VITE_APP_URL per build).
 */

export type Brand = 'dreambooth' | 'dreambooth-staging' | 'bahela' | 'klakklikkluk'

function getBrandFromHost(): Brand {
  if (typeof window === 'undefined') return 'dreambooth'
  const host = window.location.hostname
  if (host.includes('bahela')) return 'bahela'
  if (host.includes('klakklikkluk')) return 'klakklikkluk'
  if (host.includes('staging')) return 'dreambooth-staging'
  return 'dreambooth'
}

let cachedBrand: Brand | null = null

export function getBrand(): Brand {
  if (cachedBrand === null) cachedBrand = getBrandFromHost()
  return cachedBrand
}

export function isBahela(): boolean {
  return getBrand() === 'bahela'
}

export function isDreambooth(): boolean {
  const b = getBrand()
  return b === 'dreambooth' || b === 'dreambooth-staging'
}

export function isKlakklikkluk(): boolean {
  return getBrand() === 'klakklikkluk'
}

export function getBrandProductName(): string {
  const brand = getBrand()
  if (brand === 'bahela') return 'Bahela'
  if (brand === 'klakklikkluk') return 'Klakklikkluk'
  if (brand === 'dreambooth-staging') return 'Dreambooth Staging'
  return 'Dreambooth'
}

export function getGalleryBaseUrl(): string {
  return process.env.VITE_GALLERY_URL || 'https://dreamboothstudio.com/gallery'
}

/** Support/contact domain for consent and help text */
export function getSupportDomain(): string {
  const brand = getBrand()
  if (brand === 'bahela') return 'bahela.id'
  if (brand === 'klakklikkluk') return 'klakklikkluk.com'
  return 'dreamboothstudio.com'
}

export function getDocumentTitle(): string {
  return `${getBrandProductName()} - Photobooth App`
}

/** Logo image path for navbar/header (public URL path) */
export function getBrandLogoPath(): string {
  const brand = getBrand()
  if (brand === 'bahela') return '/assets/bahela/bahela-green.webp'
  if (brand === 'klakklikkluk') return '/assets/klakklikkluk/icon.png'
  return '/assets/images/dreambooth.png'
}
